import React from 'react';
import PartnersIcon from '@mui/icons-material/ZoomInMap';
import TeamsIcon from '@mui/icons-material/Group';
import RejectedIcon from '@mui/icons-material/PersonAddDisabled';
import RouteIcon from '@mui/icons-material/Route';
import ImageIcon from '@mui/icons-material/Image';
import FileIcon from '@mui/icons-material/AttachFile';
import CommentsIcon from '@mui/icons-material/Comment';
import RescheduleIcon from '@mui/icons-material/Update';
import OutOfScheduleIcon from '@mui/icons-material/AlarmOff';
import MissingSignatureIcon from '@mui/icons-material/RateReview';
import ModifiedStatusIcon from '@mui/icons-material/TrendingUp';
import ManagerIcon from '@mui/icons-material/SupportAgent';
import RecurrentIcon from '@mui/icons-material/Cached';
import GroupIcon from '@mui/icons-material/Assignment';
import VolumeIcon from '@mui/icons-material/DynamicFeed';
import StarIcon from '@mui/icons-material/Star';

import InventoriesIcon from '@assets/icons/inventory-icon.svg';
import AssetsIcon from '@assets/icons/assets-icon.svg';
import FormsFinishedIcon from '@assets/icons/form-finished-icon.svg';
import FormsIconGreen from '@assets/icons/form-green-icon.svg';
import FormsIcon from '@assets/icons/form-icon.svg';
import FormsIconYellow from '@assets/icons/form-yellow-icon.svg';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const STATUS_FINISHED = 'FINISHED';
const STATUS_NOT_APPROVED = 'NOT_APPROVED';
const STATUS_IN_REVIEW = 'IN_REVIEW';

const IconImg = styled('img')` height: 24px;width: 24px; `;

export const buildTaskDetailIcons = (icons = {}, lan) => {
	if (!lan) return [];
	const {
		rejected, volumeTask, recurrentTask, group, route, team, manager, document, partner, image, comments,
		reschedule, outOfSchedule, modified, missingFormsSignature, rating, ratingComment
	} = icons;
	const taskIcons = [];
	if (rejected) taskIcons.push({ icon: <RejectedIcon />, text: lan.DO_REJECT_TASK_AGENT });
	if (volumeTask) taskIcons.push({ icon: <VolumeIcon />, text: lan.volumeTask });
	if (recurrentTask) taskIcons.push({ icon: <RecurrentIcon />, text: lan.recurrentTask });
	if (group) taskIcons.push({ icon: <GroupIcon />, text: `${lan.groupTask}: ${group}` });
	if (route) taskIcons.push({ icon: <RouteIcon />, text: `${lan.route}: ${route}` });
	if (team) taskIcons.push({ icon: <TeamsIcon />, text: `${lan.team}: ${team}` });
	if (manager) taskIcons.push({ icon: <ManagerIcon />, text: `${lan.manager}: ${manager}` });
	if (partner) taskIcons.push({ icon: <PartnersIcon />, text: `${lan.partner}: ${partner}` });
	if (image) taskIcons.push({ icon: <ImageIcon />, text: `${lan.images}: ${image}` });
	if (document) taskIcons.push({ icon: <FileIcon />, text: `${lan.documents} ${document}` });
	if (comments) taskIcons.push({ icon: <CommentsIcon />, text: lan.commentTitle });
	if (reschedule) taskIcons.push({ icon: <RescheduleIcon />, text: lan.rescheduledDate });
	if (outOfSchedule) taskIcons.push({ icon: <OutOfScheduleIcon />, text: lan.outOfBranchOrClientSchedule });
	if (modified) taskIcons.push({ icon: <ModifiedStatusIcon />, text: `${lan.statusModifiedByUser}: ${modified}` });
	if (missingFormsSignature) taskIcons.push({ icon: <MissingSignatureIcon />, text: lan.missingFormsToSign });
	if (rating) {
		const visualBias = [0, 0.22, 0.42, 0.63, 0.85, 1];
		const percentage = visualBias[rating] * 90;
		taskIcons.push({
			icon: (
				<Box sx={{ position: 'relative', width: 24, height: 24 }}>
					<StarIcon sx={{ color: 'gray', position: 'absolute', top: 0, left: 0 }} />
					<Box sx={{ width: `${percentage}%`, overflow: 'hidden', position: 'absolute', top: 0, left: 0, }}>
						<StarIcon sx={{ color: '#FFD700' }} />
					</Box>
				</Box>
			),
			text: (<>{lan.rating}: {rating}{ratingComment && (<><br />{lan.comment}: {ratingComment}</>)}</>),
		});
	}
	return taskIcons;
};
export const buildFunctionalityIcons = ({ forms, assets, inventory } = {}, lan) => {
	if (!lan) return [];
	const taskIcons = [];
	const getFormsFunctionality = () => {
		let icon;
		let tooltipTitle = null;
		switch (forms.status) {
			case STATUS_FINISHED:
				icon = <IconImg src={FormsIconGreen} />;
				tooltipTitle = lan.AllFormsFinished;
				break;
			case STATUS_NOT_APPROVED:
				icon = <IconImg src={FormsFinishedIcon} />;
				tooltipTitle = lan.hasNotApprovedForms;
				break;
			case STATUS_IN_REVIEW:
				icon = <IconImg src={FormsIconYellow} />;
				tooltipTitle = lan.inReviewForms;
				break;
			default:
				icon = <IconImg src={FormsIcon} />;
		}
		const text = (
			<React.Fragment>
				{tooltipTitle && (
					<React.Fragment>
						<b className='mx-auto'>{tooltipTitle}</b>
						<br />
					</React.Fragment>
				)}
				<span className='mx-auto'>
					{`${lan.finishedForms}: ${forms?.finishedCount || 0} ${lan.of} ${forms.totalCount}`}
				</span>
			</React.Fragment>
		);
		return { text, icon };
	};
	if (forms && forms.totalCount) {
		const { icon, text } = getFormsFunctionality();
		taskIcons.push({ text, icon, type: 'forms' });
	}
	if (assets && assets.totalCount)
		taskIcons.push({ text: lan.assets, icon: <IconImg src={AssetsIcon} />, type: 'assets' });
	if (inventory && inventory.totalCount)
		taskIcons.push({ text: lan.inventories, icon: <IconImg src={InventoriesIcon} />, type: 'inventory' });
	return taskIcons;
};
